import React from 'react';
import { BackupConfig } from './types';

interface Props {
  config: BackupConfig;
  onConfigChange: (c: BackupConfig) => void;
}

const S3ConfigForm: React.FC<Props> = ({ config, onConfigChange }) => {
  return (
    <div className="mt-8 grid grid-cols-1 md:grid-cols-2 gap-4">
      <div>
        <label className="block text-sm font-medium text-slate-700 dark:text-slate-300 mb-1">
          Access Key ID
        </label>
        <input
          type="text"
          value={config.s3?.accessKeyId || ''}
          onChange={(e) =>
            onConfigChange({ ...config, s3: { ...(config.s3 || {}), accessKeyId: e.target.value } })
          }
          className="w-full px-3 py-2 border border-slate-300 dark:border-slate-600 rounded-lg bg-white dark:bg-slate-700"
        />
      </div>
      <div>
        <label className="block text-sm font-medium text-slate-700 dark:text-slate-300 mb-1">
          Secret Access Key
        </label>
        <input
          type="password"
          value={config.s3?.secretAccessKey || ''}
          onChange={(e) =>
            onConfigChange({
              ...config,
              s3: { ...(config.s3 || {}), secretAccessKey: e.target.value },
            })
          }
          className="w-full px-3 py-2 border border-slate-300 dark:border-slate-600 rounded-lg bg-white dark:bg-slate-700"
        />
      </div>
      <div>
        <label className="block text-sm font-medium text-slate-700 dark:text-slate-300 mb-1">
          Region
        </label>
        <input
          type="text"
          value={config.s3?.region || ''}
          onChange={(e) =>
            onConfigChange({ ...config, s3: { ...(config.s3 || {}), region: e.target.value } })
          }
          className="w-full px-3 py-2 border border-slate-300 dark:border-slate-600 rounded-lg bg-white dark:bg-slate-700"
        />
      </div>
      <div>
        <label className="block text-sm font-medium text-slate-700 dark:text-slate-300 mb-1">
          Bucket
        </label>
        <input
          type="text"
          value={config.s3?.bucket || ''}
          onChange={(e) =>
            onConfigChange({ ...config, s3: { ...(config.s3 || {}), bucket: e.target.value } })
          }
          className="w-full px-3 py-2 border border-slate-300 dark:border-slate-600 rounded-lg bg-white dark:bg-slate-700"
        />
      </div>
      <div>
        <label className="block text-sm font-medium text-slate-700 dark:text-slate-300 mb-1">
          Endpoint (optional for S3 compatible)
        </label>
        <input
          type="text"
          value={config.s3?.endpoint || ''}
          onChange={(e) =>
            onConfigChange({ ...config, s3: { ...(config.s3 || {}), endpoint: e.target.value } })
          }
          className="w-full px-3 py-2 border border-slate-300 dark:border-slate-600 rounded-lg bg-white dark:bg-slate-700"
        />
      </div>
      <div className="flex items-center space-x-6">
        <label className="flex items-center gap-2 text-sm text-slate-700 dark:text-slate-300">
          <input
            type="checkbox"
            checked={!!config.s3?.forcePathStyle}
            onChange={(e) =>
              onConfigChange({
                ...config,
                s3: { ...(config.s3 || {}), forcePathStyle: e.target.checked },
              })
            }
            className="h-4 w-4"
          />
          Path-style URLs
        </label>
        <label className="flex items-center gap-2 text-sm text-slate-700 dark:text-slate-300">
          <input
            type="checkbox"
            checked={!!config.s3?.ssl}
            onChange={(e) =>
              onConfigChange({ ...config, s3: { ...(config.s3 || {}), ssl: e.target.checked } })
            }
            className="h-4 w-4"
          />
          Use SSL
        </label>
      </div>
    </div>
  );
};

export default S3ConfigForm;
